var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.titleObj.showDate
      ? _c(
          "div",
          { staticClass: "flex align-items-center" },
          [
            _vm.dateArr.length < 2
              ? _c("div", { staticClass: "text-59" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(_vm.dateArr[0].label).d(_vm.dateArr[0].text)
                      ) +
                      "\n    "
                  ),
                ])
              : _c(
                  "yxtf-dropdown",
                  {
                    attrs: { "custom-elm": "" },
                    on: {
                      "visible-change": _vm.onDropdownVisible,
                      command: _vm.handleDateChange,
                    },
                  },
                  [
                    _c(
                      "yxtf-button",
                      {
                        staticClass: "date-select-btn",
                        attrs: { type: "text" },
                      },
                      [
                        _vm._v(
                          "\n       " +
                            _vm._s(
                              _vm
                                .$t(_vm.activeDate.label)
                                .d(_vm.activeDate.text)
                            ) +
                            "\n       "
                        ),
                        _c("i", { staticClass: "ml4", class: _vm.iconClass }),
                      ]
                    ),
                    _c(
                      "yxtf-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.dateArr, function (item, index) {
                        return _c(
                          "yxtf-dropdown-item",
                          {
                            key: index,
                            class: {
                              "color-primary-6-i":
                                item.type === _vm.titleObj.defaultDateType,
                            },
                            attrs: { command: item },
                          },
                          [_vm._v(_vm._s(_vm.$t(item.label).d(item.text)))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
            ["deptAvg", "deptSum"].includes(_vm.titleObj.objectCode)
              ? _c(
                  "yxt-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      placement: "top",
                      content: _vm
                        .$t(_vm.activeDate.tip)
                        .d(_vm.activeDate.tipText),
                    },
                  },
                  [
                    _c("yxt-svg", {
                      staticClass: "color-gray-6 hover-primary-6 hand ml6",
                      attrs: {
                        width: "16px",
                        height: "16px",
                        "icon-class": "icons/question-cirlce-o",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }